module.exports = __webpack_public_path__ + "36d6d4b587b314b9c669306eaacbe8ff.jpg";